import { useContext } from 'react';
import { MatriculaContext } from './matricula.provider';
import { Hook } from './matricula.types';

export const useMatricula: Hook = () => {
  const context = useContext(MatriculaContext);

  return {
    getSelecionadaVO: () => context?.selecionadaVO,
    getSelecionada: () => context?.selecionada,
    getPrimeiraAtiva: () => context.primeira,
    setSelecionada: (param) => {
      if (context && context.setSelecionada) {
        context.setSelecionada(param);
      }
    },
    atualizarPorEntrega: (idEntrega: string) => {
      if (context && context.atualizarPorEntrega) {
        context.atualizarPorEntrega(idEntrega);
      }
    },
    remover: () => {
      if (context && context.remover) {
        context.remover();
      }
    },
  };
};
